__turbopack_context__.v({
  "price": "ProductPrice-module___wCPpq__price",
  "root": "ProductPrice-module___wCPpq__root",
});
